//Proofed
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'
import FilterListIcon from '@mui/icons-material/FilterList'
import UpdateIcon from '@mui/icons-material/Update'
import SearchIcon from '@mui/icons-material/Search'
import { NoticeFeedPage, type NoticeFeedConfig } from './NoticeFeedPage'

const cfg: NoticeFeedConfig = {
    typeint: 1,
    showDeadline: true,
    basePath: '/tenderresults',
    noun: 'Live Tenders',
    metaTitle: 'Live Tenders',
    metaDescription: 'Search live UK & Ireland public sector tenders in real time. Filter by keyword, region, contract value and sector across 200+ procurement portals including Find a Tender.',
    keywordMetaDescription: k => `Live ${k} tenders from every UK & Ireland public sector portal, updated in real time. Filter by region and contract value or set up alerts with Contract Finder Pro.`,
    heroHighlight: 'Every Live',
    heroRest: 'UK & Ireland Public Sector Tender',
    heroSub: 'Contract Finder Pro aggregates tenders from every major UK & Ireland public sector portal into a single, searchable, real-time feed so you never have to check multiple sources again',
    searchPlaceholder: 'Search tenders by keyword, buyer or category…',
    listTitleAll: 'All Live Tenders',
    featuresTitle: 'Built for Bid Teams',
    features: [
        {
            Icon: NotificationsActiveIcon,
            title: 'Real-Time Publication',
            body: 'Tenders appear on CFP within minutes of being published on Find a Tender, Contracts Finder and 200+ additional portals',
        },
        {
            Icon: FilterListIcon,
            title: 'Powerful Filtering',
            body: 'Filter by buyer, category, CPV code, contract value, portal and region. Save your filters as named profiles for instant reuse',
        },
        {
            Icon: UpdateIcon,
            title: 'Smart Deadline Tracking',
            body: 'Never miss a close date. CFP tracks deadlines and sends reminders so your team always has time to prepare a quality submission',
        },
        {
            Icon: SearchIcon,
            title: 'Full Text Search',
            body: 'Search across tender titles, buyers, descriptions, CPV codes and regions to find the opportunities most relevant to your business',
        },
    ],
}

export default function LiveTenders() {
    return <NoticeFeedPage cfg={cfg} />
}
